import React from 'react'
import clone from 'clone'

class RestrictionInputField extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            url: clone(props.url)
        }
    }

    render () {
        const { url } = this.state

        return <div>
            <div className="col-sm-8" style={{
                paddingBottom: '1rem'
            }}>
                <input
                    type="text"
                    placeholder="Domain &hellip;"
                    className="form-control"
                    value={url || ''}
                    onChange={event => {
                        this.setState({
                            url: event.target.value
                        })
                    }}
                />
            </div>

            <div className="col-sm-4">
                <button type="button"
                    disabled={url === this.props.url || url === ''}
                    className="btn btn-default"
                    style={{ marginRight: '.5rem' }}
                    onClick={this.props.handleUpsert.bind(
                        null,
                        this.state.url
                    )}
                >
                    Update
                </button>

                <button type="button"
                    className="btn btn-danger"
                    onClick={this.props.handleRemove}
                >
                    Remove
                </button>
            </div>
        </div>
    }
}

export default RestrictionInputField